import React from 'react';
import styled from 'styled-components';

const ProductName = styled.div`
  font-weight: 900;
  width: 100%; // Ensure 100% width of its container
`;

const ProductPrice = styled.div`
  font-size: 13px;
  color: #666;
  font-weight: normal;
  padding-bottom: 16px;
`;

const ProductImageContainer = styled.div`
  margin-bottom: 20px;
  max-width: 72%; // Max width of the image container
  width: 300px; // Starting width of the image container
  border: 1px solid #e0e0e0;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); // subtle drop shadow

  img {
    width: 100%; // Ensuring image scales within container
    height: auto; // Maintain aspect ratio
  }
`;

const CartItemProductNameImage = ({ cartItem }) => {
  const price = (cartItem.price || 0) / 100;
  const priceDisplay = price === 0 ? 'Free' : `$${price.toFixed(2)}`;

  return (
    <>
      <ProductName>{cartItem.productName}</ProductName>
      <ProductPrice>{priceDisplay}</ProductPrice>
      <ProductImageContainer>
        <img src={cartItem.imageThumbnail} alt={cartItem.productName} />
      </ProductImageContainer>
    </>
  );
};

export default CartItemProductNameImage;
